import React from 'react';
import { Heading } from '../../components';
import css from '../../containers/ListingPage/ListingPage.module.css';

import { FaBath, FaPalette, FaQuestion,} from 'react-icons/fa';
import {FaBugSlash, FaEarListen, FaShieldDog, FaSprayCanSparkles, FaSun } from "react-icons/fa6";
import { GiComb, GiDogHouse,GiJumpingDog, GiNailedHead, } from 'react-icons/gi';
import { RiHomeHeartLine, RiScissors2Line  } from 'react-icons/ri';
import { LuPawPrint, LuSquareScissors } from "react-icons/lu";
import { PiClipboardText } from "react-icons/pi";
import { SiDatadog } from "react-icons/si";
import { RxScissors } from "react-icons/rx";




const serviceDisplayData = { 
  boarding_type: {
    name: 'Boarding',
    icon: <GiDogHouse size={20} />,
  },
  daycare_type: {
    name: 'Daycare',
    icon: <FaSun size={20} />,
  },
  sitting: {
    name: 'Sitting',
    icon: <RiHomeHeartLine size={20} />,
  },
  walking: {
    name: 'Walking',
    icon: (
      <>
        <LuPawPrint size={12} />
        <LuPawPrint size={12} />
      </>
    ),
  },
  // training: {
  //   name: 'Training',
  //   icon: <GiJumpingDog size={20} />,
  // },
  // spa: {
  //   name: 'Spa',
  //   icon: <FaSprayCanSparkles size={20} />,
  // },
  // behavior_assessment: {
  //   name: 'Behavior Assessment',
  //   icon: <PiClipboardText size={20} />,
  // },
  // puppy_social: {
  //   name: 'Puppy Social',
  //   icon: <SiDatadog size={20} />,
  // },
  // grooming: {
  //   name: 'Grooming',
  //   icon: <RiScissors2Line size={20} />,
  // },
  // trainer: {
  //   name: 'Trainer',
  //   icon: <FaShieldDog size={20} />,
  // },
  // bathing: {
  //   name: 'Bathing',
  //   icon: <FaBath />,
  // },
  // nail_trim: {
  //   name: 'Nail Trimming',
  //   icon: <GiNailedHead />,
  // },
  // ear_clean: {
  //   name: 'Ear Cleaning',
  //   icon: <FaEarListen />,
  // },
  // haircut: {
  //   name: 'Haircut',
  //   icon: <RiScissors2Line />,
  // },
  // tick_treatment: {
  //   name: 'Tick/Flea Treatment',
  //   icon: <FaBugSlash />,
  // },
  // de_shedding: {
  //   name: 'De-Shedding',
  //   icon: <GiComb />,
  // },
  // show_grooming: {
  //   name: 'Show Grooming',
  //   icon: <LuSquareScissors style={{fill:'none'}} />,
  // },
  // creative_grooming: {
  //   name: 'Creative Grooming',
  //   icon: <RxScissors />,
  // },
};

const SectionOtherServices = props => {
  const { heading, selectedOptions = [] } = props;
  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.cleaningFacilitiesList}>
        {selectedOptions.filter(option=>serviceDisplayData[option]).map(option => {
          const service = serviceDisplayData[option];
          return (
            <li key={option} className={css.multiEnumItem}>
              <span className={css.facilityIcon}>{service?.icon || <FaQuestion />}</span>
              <span>{service?.name || option}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionOtherServices;
